export default "__VITE_ASSET__ef06fe1d__"